import dealerName from './setDealerName';
import reviews from './setReviews';
import filters from './setFilters';
import sort from './setSort';
import pageInfo from './setPageInfo';

const root = {
	dealerName,
	reviews,
	pageInfo,
	filters,
	sort
};

export default root;
